<template>
  <div
    data-testid="accruals-system-instruction-panel"
    class="accruals-system-instruction-panel"
  >
    <div data-testid="accruals-system-instruction-panel__card" class="accruals-system-instruction-panel__card">
      <div class="accruals-system-instruction-panel__card-header">
        <div class="accruals-system-instruction-panel__card-title-row">
          <div class="accruals-system-instruction-panel__card-icon-wrap">
            <img
              :src="instructions.cardIcon"
              alt=""
              class="accruals-system-instruction-panel__card-icon"
              aria-hidden="true"
            />
          </div>
          <h3 class="accruals-system-instruction-panel__card-title">{{ instructions.cardTitle }}</h3>
        </div>

        <base-button
          v-if="!isEditing"
          secondary
          small
          class="shadow-off"
          image="/img/icons/fbc-icons/PencilEdit01.svg"
          image-alt=""
          label="Edit"
          data-testid="accruals-system-instruction-panel__edit"
          @click="startEdit"
        />

        <div v-else class="accruals-system-instruction-panel__actions">
          <base-button
            secondary
            small
            class="shadow-off"
            label="Cancel"
            data-testid="accruals-system-instruction-panel__cancel"
            @click="cancelEdit"
          />
          <base-button
            primary
            small
            class="shadow-off"
            label="Save"
            :disabled="!canSave"
            data-testid="accruals-system-instruction-panel__save"
            @click="onSave"
          />
        </div>
      </div>

      <p data-testid="accruals-system-instruction-panel__subtitle" class="accruals-system-instruction-panel__subtitle">
        {{ instructions.subtitle }}
      </p>

      <div
        v-if="!isEditing"
        data-testid="accruals-system-instruction-panel__content"
        class="accruals-system-instruction-panel__content"
      >
        <p
          v-for="(paragraph, index) in displayParagraphs"
          :key="`paragraph-${index}`"
          :data-testid="`accruals-system-instruction-panel__paragraph--${index}`"
          class="accruals-system-instruction-panel__paragraph"
        >
          {{ paragraph }}
        </p>
      </div>

      <textarea
        v-else
        v-model="draftText"
        data-testid="accruals-system-instruction-panel__textarea"
        class="accruals-system-instruction-panel__textarea"
        :placeholder="instructions.placeholder"
        :maxlength="charLimit"
        rows="12"
      />

      <div data-testid="accruals-system-instruction-panel__status" class="accruals-system-instruction-panel__status">
        <img
          src="/img/icons/fbc-icons/Tick01.svg"
          alt=""
          class="accruals-system-instruction-panel__status-icon"
          aria-hidden="true"
        />
        <span class="accruals-system-instruction-panel__status-label">{{ statusLabel }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ADMIN_CONSOLE_ACCRUALS_CHAR_LIMIT,
  ADMIN_CONSOLE_ACCRUALS_INSTRUCTIONS,
} from '@/modules/admin/utils/adminConsoleConstants';

export default {
  name: 'AccrualsSystemInstructionPanel',
  data() {
    return {
      isEditing: false,
      instructionText: ADMIN_CONSOLE_ACCRUALS_INSTRUCTIONS.defaultText,
      savedInstructionText: ADMIN_CONSOLE_ACCRUALS_INSTRUCTIONS.defaultText,
      draftText: '',
      instructions: ADMIN_CONSOLE_ACCRUALS_INSTRUCTIONS,
      charLimit: ADMIN_CONSOLE_ACCRUALS_CHAR_LIMIT,
    };
  },
  computed: {
    canSave() {
      return this.draftText !== this.savedInstructionText;
    },
    displayParagraphs() {
      return String(this.instructionText || '')
        .split(/\n\n+/)
        .map((p) => p.trim())
        .filter(Boolean);
    },
    statusLabel() {
      const count = this.isEditing
        ? (this.draftText || '').length
        : (this.instructionText || '').length;
      const withinLimit = count <= this.charLimit;
      return `${count} characters · ${withinLimit ? 'Within limit' : `${this.charLimit} limit`}`;
    },
  },
  methods: {
    startEdit() {
      this.draftText = this.instructionText;
      this.isEditing = true;
    },
    cancelEdit() {
      this.draftText = this.savedInstructionText;
      this.isEditing = false;
    },
    onSave() {
      this.savedInstructionText = this.draftText;
      this.instructionText = this.draftText;
      this.isEditing = false;
      console.log('[AccrualsSystemInstructionPanel]: save instructions');
    },
  },
};
</script>

<style lang="scss" scoped src="./AccrualsSystemInstructionPanel.scss"></style>
